import { render, staticRenderFns } from "./update-renewal.vue?vue&type=template&id=ef1df920&"
import script from "./update-renewal.vue?vue&type=script&lang=js&"
export * from "./update-renewal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports